import React from 'react';
import {
  Banner,
  Title
} from '@patternfly/react-core';

class Forms extends React.Component {

  render() {
    return (
      <div>
      	<Banner variant="info">Forms and Documents</Banner>
          <Title headingLevel="h1" size="2x1">
	          Need updated forms and links here!  Old site has outdated links!
	        </Title>
      </div>
    );
  }
}

export default Forms;

